/**
 * @generated SignedSource<<38a93b19d2769dfcf956a0d42da6719c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuyerPriceTableFormatStylesType = "DISCOUNT" | "%future added value";
export type BuyerPriceTableRowTypeType = "ADDITIONAL_CHARGE" | "AUCTION_SECOND_CHANCE_PRICE" | "AUSTRALIAN_GST" | "BUYER_DUTIES_TAX" | "BUY_IT_NOW_PRICE" | "COMPLIMENTARY_SHIPPING" | "CREDIT" | "CURRENT_BID_PRICE" | "CUSTOM_MOD" | "DEALER_SHIPMENT_REFUND" | "FIRSTDIBS_SHIPMENT_REFUND" | "ITEM_REFUND" | "LIST_PRICE" | "NEGOTIATED_DISCOUNT" | "PRICE" | "PRICE_DISCOUNT" | "PRICE_MOD" | "PROMO" | "PROMOTION" | "PUR_PRICE" | "QUANTITY" | "SALES_TAX" | "SHIPPING" | "SHIPPING_SUBSIDY" | "TOTAL" | "TOTAL_REFUND" | "TOTAL_SALES_TAX" | "WINNING_BID_PRICE" | "%future added value";
export type BuyerPriceTableType = "MAIN" | "REFUND" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPriceTable_transaction$data = {
  readonly buyerPriceTables: {
    readonly tables: ReadonlyArray<{
      readonly rows: ReadonlyArray<{
        readonly formatStyle: BuyerPriceTableFormatStylesType | null;
        readonly hasTopBorder: boolean | null;
        readonly label: string | null;
        readonly rowType: BuyerPriceTableRowTypeType | null;
        readonly subLabel: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly type: BuyerPriceTableType | null;
    } | null> | null;
  } | null;
  readonly priceBookName: string | null;
  readonly vatAmount: {
    readonly amount: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryQuantitySelect_transaction">;
  readonly " $fragmentType": "CheckoutMobileSummaryPriceTable_transaction";
};
export type CheckoutMobileSummaryPriceTable_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryPriceTable_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPriceTable_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "displayCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPriceTable_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryQuantitySelect_transaction"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "displayCurrency",
          "variableName": "displayCurrency"
        }
      ],
      "concreteType": "BuyerPriceTables",
      "kind": "LinkedField",
      "name": "buyerPriceTables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BuyerPriceTable",
          "kind": "LinkedField",
          "name": "tables",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BuyerPriceTableRow",
              "kind": "LinkedField",
              "name": "rows",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formatStyle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasTopBorder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "vatAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "28b558eee4df61952c30483239422305";

export default node;
